import { render, staticRenderFns } from "./used.vue?vue&type=template&id=99b49c5c&scoped=true&"
import script from "./used.vue?vue&type=script&lang=js&"
export * from "./used.vue?vue&type=script&lang=js&"
import style0 from "./used.vue?vue&type=style&index=0&id=99b49c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b49c5c",
  null
  
)

export default component.exports